GP.GPMod('Cometd',function(self) {
    // config flags/settings
    var _conf = {
        disable_websockets: false,
        test_websockets_lh: false, // test local websocket object for android phones
        force_proxy:        false, // force connection to rt/push through nginx proxy (same domain, bypassing CORS issues)
        use_secure:         true,  // toggle using secure/non secure port for cometd url
        self_load_balance:  false, // use the load balancer or load balance ourselves

        cookie_push_domain:     null,
        cookie_prod_url:        null,

        basic_port:         80,    // non secure port (through LB) for CometD (http/ws)
        secure_port:        443,   // secure port (through LB) for SSL (https/wss)
        test_port:          8080,  // test build's non secure port (through LB and direct to server) for CometD (http/ws)
        test_secure_port:   8081,  // test build's secure port (through LB and direct to server) for SSL (https/wss)

        push_domain:        'push.gpstreaming.com',

        push_uri_path:      '/rt/serve'
    };

    var _cookie_names = {
        push_domain:        'push_domain',
        prod_url:           'prod_push_url',
        disable_websockets: 'push_disable_ws'
    };

    // convenience/shortcut class variables that will reference other modules/functions etc
    var _cometD       = null,      // cometd library/framework object ref
        _vent         = null,
        _util         = null,
        _info         = null,
        _log          = null,
        _log_console  = null,
        _check_obj    = function() {},
        _handler_wrap = function (func) {return function () {return func.apply(this, arguments);};};



    // class object for storing state/config data needed
    var _data = {
        handshake_count: 0,
        // different urls that we can connect to push/cometd servers
        push_url:    null,
        proxy_url:   null,
        non_ssl_url: null,

        // some basic user data to send with handshake for authentication
        duid:            null,
        username:        null,
        auth_hash:       null,
        auth_hash_email: null,

        // some flags representing the current state of the cometd connection
        my_user_obj_fetched: false,
        handshake_denied:    false,
        connected:           false,
        was_connected:       false,
        log_connected:       false,
        log_connection:      false,
        try_proxy:           false,
        try_non_ssl:         false,

        // objects for keeping track of the channels/subscriptions etc
        push_channels:        {},
        af_subscriptions:     {},
        thread_subscriptions: {},
        user_subscriptions:   {},

        // timer to check if we are connected, and switch to proxy if not
        check_connection_timeout: 5000,

        // timer to log connection success/transport used, or failure to connect
        log_connection_timeout:   20000,

        // interval to check/update logged in/online status
        check_connection_interval: 120000,
        timer_ns:                  'cometd_',

        // data to send cometd handshake
        cometd_config: {
            url:              null,
            backoffIncrement: 2000,
            maxBackoff:       180000,
            logLevel:         'info'  // should be info
        },
        messenger_thread_subscription: {
            channel: null,
            handler: null
        },
        prod_servers: {
            secure: [
                'https://push1.gpstreaming.com:8083' + _conf.push_uri_path,
                'https://push2.gpstreaming.com:8083' + _conf.push_uri_path
            ],
            basic: [
                'https://push1.gpstreaming.com:8082' + _conf.push_uri_path,
                'https://push2.gpstreaming.com:8082' + _conf.push_uri_path
            ]
        },
        test_servers: {
            secure: [
                'https://push1.gpstreaming.com:8081' + _conf.push_uri_path,
                'https://push2.gpstreaming.com:8081' + _conf.push_uri_path
            ],
            basic: [
                'http://push1.gpstreaming.com:8080' + _conf.push_uri_path,
                'http://push2.gpstreaming.com:8080' + _conf.push_uri_path
            ]
        },

        // logged_in, viewed_profile, viewed_feed, hovered_feed, favorite_added, friend_request, now_friends,
        // pic_rated, content_like, content_comment, comment_reply, video_like, video_comment, status_like, status_comment, mutual_match, private_chat, stream_started, premium_upload
        activity_msg_types:     ['li','pv','vf','hf','fa','fr','nf','pr','cl','cc','cr','vl','vc','sl','sc','mm','pc','ss','pu','er'],
        activity_feed_channels: ['o-m','o-w','o-c','o-m-f','o-w-f','o-c-f'],

        // local copy of blocked users duids
        blocked_users: [],

        // check and initialize a few params
        init: function() {
            _cometD       = $.cometd;
            _vent         = self.vent;
            _util         = self.app.Util;
            _info         = self.app.Util.info;
            _log          = self.app.Util.log;
            _log_console  = self.app.Util.log_console;
            _check_obj    = self.app.Util.check_obj;
            _handler_wrap = self.app.Util.handler_wrap;

            _conf.basic_port  = (window._push_port        || _conf.basic_port);
            _conf.secure_port = (window._push_secure_port || _conf.secure_port);

            // setup the channels the user will subscribe to
            _data.push_channels = ((_util.check_obj(window._pushChannels)) ? window._pushChannels : {});

            // setup user data (duid, auth_hash etc) for handshake
            _data.setup_user();

            // custom header to be sent with long-polling requests
            _data.cometd_config.requestHeaders = {
                'gp-cometd-header': 'duid=' + _data.duid
            };

            // configure the url to connect to based off of settings (port/ssl/basic/proxy/testing/cookie settings etc)
            _data.configure_push_url();
        },
        setup_user: function(user_obj) {
            var user = (user_obj || GP.sdata.my_user),
                location = ((user.city || '') + ', ' + (user.state_code || user.country_code || ''));

            _data.auth_hash       = (user.rt_auth_hash || '');
            _data.auth_hash_email = (user.rt_auth_hash_email || '');
            _data.duid            = (user.duid || '');
            _data.username        = (user.username || '');
            _data.gender          = (user.gender || '');
            _data.age             = (parseInt(user.age, 10) || 0);
            _data.pic_url         = (user.pic || '');
            _data.location        = location;
        },
        update_blocked_users: function(blocked_users) {
            if (typeof blocked_users != 'undefined' && blocked_users && blocked_users.length) {
                _data.blocked_users = blocked_users;
            }
        },
        configure_push_url: function() {
            // set to push1.fling.com or push2.fling.com
            _conf.cookie_push_domain  = $.cookie(_cookie_names.push_domain);
            _conf.cookie_prod_url     = $.cookie(_cookie_names.prod_url);

            var protocol = _conf.use_secure ? 'https://' : 'http://',
                port     = _conf.use_secure ? _conf.secure_port : _conf.basic_port;

            // use cookie to force push1.fling.com or push2.fling.com if set
            var domain = _conf.push_domain;
            if (_conf.cookie_push_domain) {
                domain = _conf.cookie_push_domain;
                _info('found push_domain cookie:', _conf.cookie_push_domain);
            }

            // setup our main, non ssl (basic), proxy through webserver, and url from cookie if we have one set
            _data.push_url    = protocol  + domain + ':' + port + _conf.push_uri_path;
            _data.non_ssl_url = 'http://' + domain + ':' + _conf.basic_port + _conf.push_uri_path;

            // _data.proxy_url   = window.top.location.protocol + "//" + window.top.location.host + "/rt";
            if (typeof _http_host != 'undefined' && _http_host) {
                _data.proxy_url   = "//" + _http_host + "/rt";
            } else {
                _data.proxy_url   = "//" + window.top.location.host + "/rt";
            }
            window._push_proxy_url = _data.proxy_url;

            // set the push_url to the proxy url if flag is set (mainly for testing)
            if (_conf.force_proxy) {
                _events.use_proxy(true);
                return;
            }

            // only logs to console if the console obj is available/callable
            _log('configure_push_url... push_url: %s, protocol: %s, port: %d', _data.push_url, protocol, port);

            // bypass production load balancer and randomly choose server from either secure or basic (regular/non ssl) servers
            if (_conf.self_load_balance) {
                if (_conf.cookie_prod_url) {
                    _info('found prod_push_url cookie.  Setting push_url: ', _conf.cookie_prod_url);
                    _data.push_url = _conf.cookie_prod_url;
                } else {
                    var prod_servers  = _conf.use_secure ? _data.prod_servers.secure : _data.prod_servers.basic,
                        random_server = prod_servers[Math.floor(Math.random() * prod_servers.length)];

                    _info('bypassing load balancer.  Setting push_url: ', random_server);

                    _data.push_url = random_server;
                }
            }
        }
    };

    var _apis = {
        check_online: function() {
            self.api.json('user.update_online', {
                data:    {},
                success: function(json) {
                    // should be coming back with valid json
                    if (typeof json != 'undefined' && json) {
                        // trigger reload growl if the javascript hash has changed on the server (i.e. it was updated)
                        if (json.js_hash && (json.js_hash != _js_initial_hash)) {
                            _vent.trigger('ActivityPane:add_reload_growl');
                        }

                        // if we are logged in and connected to cometd, GTFO
                        if (json.logged_in && self.check_connection()) {
                            return;
                        }
                        // if we are logged in, and not connected to cometd, try to reconnect
                        if (json.logged_in && _cometD.isDisconnected() && !_data.handshake_denied) {
                            // clear any client side references to channel subscriptions
                            _data.af_subscriptions     = {};
                            _data.thread_subscriptions = {};
                            _data.user_subscriptions   = {};

                            // lets check every minute until we are connected
                            // _data.check_connection_interval = 60000;

                            // try to reconnect
                            _events.configure_and_handshake(_data.push_url);
                        } else if (!json.logged_in && self.check_connection()) {
                            // if we aren't logged in, and are connected to cometd, disconnect and cleanup (weird random logout bug)
                           _events.cleanup();
                        }
                    }
                }
            });
        },
        post_handshake_update: function() {
            self.api.json('util.update_rt_user', {
                type: 'POST',
                data: {}
            }).done(function(json) {

            });
        }
    };

    var _events = {
        init: function() {
            // check to make sure we can use websockets, and disable if we can't
            _events.check_ws();

            // listeners for CometD meta channels (handshake/disconnect etc)
            // only need to do once, even if we switch to proxy
            _cometD_listeners.setup();

            // configure cometd with primary url, and init handshake
            _events.configure_and_handshake(_data.push_url);

            // cometd catches & logs all js exceptions in listeners which means they
            // never bubble up to window and therefore don't get sent to sentry, make them go!
            _cometD.onListenerException = function(exception, subscriptionHandle, isListener, message) {
                // GP.Errors.sentry.send_error(exception, {cometd_message: message});
                // if (typeof Sentry != 'undefined') {
                //     Sentry.captureException(exception, {
                //         extra: {
                //             exception_location: 'GP.Cometd.init',
                //             cometd_msg: message
                //         }
                //     });
                // }
            };

            $(window).on('unload', _events.cleanup);

            _vent.on(self.moduleName+":activity_carousel_subscribe",   this.activity_carousel_subscribe);
            _vent.on(self.moduleName+":activity_carousel_unsubscribe", this.activity_carousel_unsubscribe);

            _vent.on(self.moduleName+":messenger_thread_subscribe",   this.messenger_thread_subscribe);
            _vent.on(self.moduleName+":messenger_thread_unsubscribe", this.messenger_thread_unsubscribe);
            _vent.on(self.moduleName+":messenger_send_typing_status", this.messenger_send_typing_status);
            _vent.on(self.moduleName+":messenger_send_idle_status",   this.messenger_send_idle_status);
            _vent.on(self.moduleName+":messenger_send_open_status",   this.messenger_send_open_status);

            _vent.on(self.moduleName+":update_blocked_users",   _data.update_blocked_users);
        },
        check_ws: function() {
            // disable websockets transport if cookie is set (for testing http2 and other transports on the fly/live)
            var disable_websockets_cookie = $.cookie(_cookie_names.disable_websockets);
            if (typeof disable_websockets_cookie != 'undefined' && disable_websockets_cookie) {
                _log('disabling websockets via push_disable_ws cookie');
                _conf.disable_websockets = true;
            }

            // no WebSocket obj so just disable
            if (typeof WebSocket == 'undefined' || _conf.disable_websockets === true) {
                _events.disable_websocket_transport();
            } else {
                // special check for galaxy phones that have an incomplete WebSocket implementation in the stock browser
                // some implementations are missing the CLOSING property, and others have
                // binaryType and extension properties of the WebSocket missing
                // cometd's internal websocket check will miss this, so we disable here
                var has_closing = ('CLOSING' in WebSocket.prototype);
                if (has_closing === false) {
                    _events.disable_websocket_transport();
                } else if (_conf.test_websockets_lh && navigator.userAgent.match(/Android/i)) {
                    var test_ws = new WebSocket('wss://localhost');
                    if (typeof test_ws.binaryType === 'undefined' && typeof test_ws.extensions === 'undefined') {
                        _events.disable_websocket_transport();
                    }
                    test_ws.close();
                }
            }
        },
        disable_websocket_transport: function() {
            _cometD.websocketEnabled = false;
            _cometD.unregisterTransport('websocket');
        },
        configure_and_handshake: function(url) {
            if (_data.handshake_denied) {
                return false;
            }

            // add url for cometd into config
            var config = $.extend({}, _data.cometd_config, {url: url});

            // configure cometd client and init handshake
            _cometD.configure(config);

            if (self.app.User.utils.check_my_user_obj()) {
                var handshake_obj = {
                    ext: {
                        auth: {
                            duid:            parseInt(_data.duid, 10),
                            auth_hash:       _data.auth_hash + "",
                            auth_hash_email: _data.auth_hash_email + "",
                            handshake_count: ++_data.handshake_count
                        },
                    }
                };

                // connect to push/cometd via handshake
                _cometD.handshake(handshake_obj);

                // console.log supplemental handshakes
                if (_data.handshake_count > 1) {
                    _info('CALLING COMETD HANDSHAKE AGAIN()', {
                        'url': url,
                        'handshake_count': _data.handshake_count
                    });
                }
            } else if (_data.my_user_obj_fetched === false) {
                var ctx = this;
                // if we do not have a duid from GP.sdata.my_user, try to fetch it and retry
                _vent.trigger('User:fetch_my_user_obj', ctx, function(user_obj) {
                    if (typeof user_obj != 'undefined' && user_obj && user_obj.duid) {
                        _data.my_user_obj_fetched = true;
                        _data.setup_user(user_obj);

                        // retry the handshake (one time)
                        _events.configure_and_handshake(_data.push_url);
                    }
                });
            }
        },
        use_proxy: function(setup_only) {
            // disable websockets if we are using proxy (websockets through proxy don't work as well as they should)
            _cometD.websocketEnabled = false;
            _cometD.unregisterTransport('websocket');

            // change push_url to proxy_url so we don't try to connect through push again
            _data.push_url = _data.proxy_url;

            // don't call handshake if we are just setting the proxy up
            if (setup_only === true) {
                return;
            }

            // configure cometd with proxy url, and init handshake
            _events.configure_and_handshake(_data.push_url);

            // setup timer again for logging success/transport or failure
            _timers.set(_events.check_and_log_connection, _data.log_connection_timeout, 'check_and_log_connection');
        },
        use_non_ssl: function() {
            // switch from ssl to non secure http/ws
            _data.push_url = _data.non_ssl_url;

            // configure cometd with proxy url, and init handshake
            _events.configure_and_handshake(_data.push_url);

            // set the timer back up to check connection and fallback to proxy
            _timers.set(
                _events.check_connection,
                _data.check_connection_timeout,
                'check_connection'
            );

            // setup timer again for logging success/transport or failure
            _timers.set(
                _events.check_and_log_connection,
                _data.log_connection_timeout,
                'check_and_log_connection'
            );
        },
        check_connection: function() {
            if (_cometD.getStatus() != 'connected' && _data.log_connected === false) {

                // set flag for either non secure or proxy,
                // so the disconnect handler will setup connection with new url/settings
                if (!_data.try_non_ssl && !_data.try_proxy) {
                    _data.try_non_ssl = true;
                } else if (_data.try_non_ssl && !_data.try_proxy) {
                    _data.try_proxy = true;
                }

                // clear the connection checking timers
                _timers.clear('check_and_log_connection');
                _timers.clear('check_connection');

                // trigger disconnect which will also call the /meta/disconnect listener
                _cometD.disconnect();
            }
        },
        check_and_log_connection: function() {
            var comet_status   = _cometD.getStatus();
            var transport      = _cometD.getTransport();
            var transport_type = (transport && typeof transport.getType == 'function') ? transport.getType() : null;

            if (comet_status != 'connected' && _data.log_connected === false) {
                _events.log_comet_connection('setTimeOut', 'failure', '');
            } else if (comet_status == 'connected') {
                _events.log_comet_connection('setTimeOut', 'success', transport);
            }
        },
        log_comet_connection: function(called_from, log_type, transport_used) {
            if (_data.log_connection) {
                var api_data = {
                    log_type        : log_type,
                    fail_location   : called_from,
                    transport_used  : transport_used + (_data.try_proxy ? '-proxy' : '')
                };
                self.api.json('util.log_rt',{
                    data:    api_data
                });
            }
        },
        activity_carousel_subscribe: function() {
            if (_cometD.isDisconnected()) {
                return;
            }
            for (var channel in _data.af_subscriptions) {
                if (_data.af_subscriptions.hasOwnProperty(channel)) {
                    if (_data.af_subscriptions[channel] === null) {
                        try {
                            _data.af_subscriptions[channel] =
                                _cometD.subscribe(channel, _handler_wrap(_channel_handlers.handle_activity_feed, 'json_payload'));
                        } catch (e) {}
                    }
                }
            }
        },
        activity_carousel_unsubscribe: function() {
            for (var channel in _data.af_subscriptions) {
                if (_data.af_subscriptions.hasOwnProperty(channel)) {
                    if (_data.af_subscriptions[channel] !== null) {
                        try {
                            _cometD.unsubscribe(_data.af_subscriptions[channel]);
                        } catch (e) {
                            // possibly log this?
                        }
                        _data.af_subscriptions[channel] = null;
                    }
                }
            }
        },
        messenger_thread_subscribe: function(thread_id) {
            if (_cometD.isDisconnected()) {
                return;
            }
            var channel = '/msg/thread_open-' + thread_id;

            // already subscribed to this channel
            if (_data.thread_subscriptions[thread_id]) {
                return;
            }

            try {
                _data.thread_subscriptions[thread_id] = {};
                _data.thread_subscriptions[thread_id].channel = channel;
                _data.thread_subscriptions[thread_id].handler =
                    _cometD.subscribe(channel, _handler_wrap(_channel_handlers.handle_message_thread, 'duid'));
            } catch (e) {}
        },
        messenger_thread_unsubscribe: function(thread_id) {
            // not passing in a thread_id means unsubscribe from all threads (used in unload function below)
            if (typeof(thread_id) === 'undefined') {
                _.each(_data.thread_subscriptions, function(val, thread_id) {
                    if (val) {
                        _events.messenger_send_idle_status(thread_id);
                        try {
                            _cometD.unsubscribe(val.handler);
                        } catch (e) {
                            // possibly log this?
                        }
                    }
                });
                _data.thread_subscriptions = {};
                return;
            }

            if (!_data.thread_subscriptions[thread_id]) {
                return;
            }

            // publish idle status before removing handler
            _events.messenger_send_idle_status(thread_id);

            try {
                _cometD.unsubscribe(_data.thread_subscriptions[thread_id].handler);
            } catch (e) {
                // possibly log this?
            }

            // remove it from _data.thread_subscriptions
            _data.thread_subscriptions[thread_id] = null;
        },
        messenger_send_typing_status: function(thread_id) {
            if (self.check_connection() && _data.thread_subscriptions[thread_id]) {
                if (_data.thread_subscriptions[thread_id].channel) {
                    _cometD.publish(_data.thread_subscriptions[thread_id].channel, {
                        thread_id: thread_id,
                        duid:      _data.duid,
                        status:    'typing',
                    });
                }
            }
        },
        messenger_send_idle_status: function(thread_id) {
            if (self.check_connection() && _data.thread_subscriptions[thread_id]) {
                if (_data.thread_subscriptions[thread_id].channel) {
                    _cometD.publish(_data.thread_subscriptions[thread_id].channel, {
                        thread_id: thread_id,
                        duid:      _data.duid,
                        status:    'idle',
                    });
                }
            }
        },
        user_channels_unsubscribe: function() {
            // loop through all the user's channel handlers and unsubscribe
            _.each(_data.user_subscriptions, function(handler, id) {
                try {
                    _cometD.unsubscribe(handler);
                } catch (e) {
                    // possibly log this?
                }
            });
            _data.user_subscriptions = {};
        },
        cleanup: function() {
            // console.log('Cometd.js cleanup event triggered');
            // console.trace();
            // _cometD.reload();

            if (!_cometD.isDisconnected()) {
                // unsubscribe from cometd channels
                _events.activity_carousel_unsubscribe();
                _events.messenger_thread_unsubscribe();
                _events.user_channels_unsubscribe();
            }

            // log and disconnect
            _events.log_comet_connection('window.unload', 'message_count', '');
            _cometD.disconnect();
        },
        messenger_send_open_status: function(thread_id) {
            if (self.check_connection() && _data.thread_subscriptions[thread_id]) {
                if (_data.thread_subscriptions[thread_id].channel) {
                    _cometD.publish(_data.thread_subscriptions[thread_id].channel, {
                        thread_id: thread_id,
                        duid:      _data.duid,
                        status:    'messenger_open',
                    });
                }
            }
        }
    };


    var _cometD_listeners = {
        setup: function() {
            // add _cometD_listeners for cometd meta channels
            _cometD.addListener('/meta/handshake',  _cometD_listeners.meta_handshake);
            _cometD.addListener('/meta/connect',    _cometD_listeners.meta_connect);
            _cometD.addListener('/meta/disconnect', _cometD_listeners.meta_disconnect);
        },
        meta_handshake: function(handshake) {
            if (handshake.successful === true) {
                // log successful connection to push server and what url (only logs to console if available)
                _log('PUSH SUCCESSFULLY CONNECTED to: ', _data.push_url);

                // make call to backend to trigger api call to push to update push user data (pics, location etc)
                _apis.post_handshake_update();

                // publish on service channel after successful handshake to update server stats
                // _cometD.publish('/service/client/info', {duid: _data.duid});

                // write a cookie to have this client connect to the same url they successfully connected to
                // if we're bypassing the load balancer and don't already have that cookie
                if (_conf.self_load_balance) {
                    _info('writing prod_push_url cookie to: ', _data.push_url);
                    _util.set_cookie('prod_push_url', _data.push_url, 7);
                }

                // setup the handlers for the channels a user should subscribe to
                _channel_handlers.setup();

                // trigger general event announcing cometd handshake success/connected
                // so anything that needs cometd can listen for this event
                _vent.trigger('cometd:connected');
            } else if (handshake.successful === false && handshake.ext && handshake.ext.gp_auth_fail) {
                // handshake auth denied from server... disconnect
                _data.handshake_denied = true;
                _cometD.disconnect(true);

                // redirect to logout?  probably should, but hold off for now
                // window.location.href = '/members/user/logout';
            }
        },
        meta_connect: function(message) {
            if (_cometD.isDisconnected()) {
                _data.connected = false;
                return;
            }

            _data.was_connected = _data.connected;
            _data.connected = message.successful === true;

            if (!_data.was_connected && _data.connected) {
                _data.log_connected = true;
            }
        },
        meta_disconnect: function(message) {
            if (_data.try_non_ssl && !_data.try_proxy) {
                _events.use_non_ssl();
            } else if (_data.try_proxy) {
                _events.use_proxy();
            }
        }
    };

    var _channel_handlers = {
        setup: function() {
            // loop through all the channels the user should subscribe to, and assign handlers
            $.each(_data.push_channels, function(channel_id, channel_value) {
                var channel = channel_value.trim();

                // channel all users are subscribed to.  For broadcasting stuff to all users
                if (channel_id == 'a') {
                    _data.user_subscriptions[channel] =
                        _cometD.subscribe(channel, _handler_wrap(_channel_handlers.all, 'msg_type'));

                // a user's personal channel that only they are subscribed to
                } else if (channel_id == 'm-c') {
                    _data.user_subscriptions[channel] =
                        _cometD.subscribe(channel, _handler_wrap(_channel_handlers.my_channel, 'msg_type'));

                // channel_id is an activity feed channel
                } else if ($.inArray(channel_id, _data.activity_feed_channels) !== -1) {
                    var af = $('#activity-feed');
                    if (af.length && af.is(':visible')) {
                        _data.af_subscriptions[channel] =
                            _cometD.subscribe(channel, _handler_wrap(_channel_handlers.handle_activity_feed, 'json_payload'));
                    } else {
                        _data.af_subscriptions[channel] = null;
                    }
                }
            });
        },
        all: function(message) {
            // force user to reload a script
            if (message.data.msg_type == 'reload') {
                var json = _util.parse_json(message.data.json_payload);
                if (_util.check_obj(json.script)) {
                    var ts     = new Date().getTime(); // timestamp for cache busting
                    var prefix = json.prefix || '/js'; // path prefix for src (i.e. /js or /js_v3 etc...)

                    $("script[src*='" + json.script + "']").remove();
                    $('<script>').attr('src', prefix + '/' + ts + '/' + json.script + '.js').appendTo('body');
                }
            } else if (message.data.msg_type == 'reload_growl') {
                _vent.trigger('ActivityPane:add_reload_growl');
            } else if (message.data.msg_type == 'videochat_streaming_now') {
                _vent.trigger('Profile:stream_started', _util.parse_json(message.data.json_payload));
            }
        },
        my_channel: function(message) {
            // console.warn('cometd my_channel() raw message: ', $.extend(true, {}, message));
            var msg_type = message.data.msg_type;
            var json = (message.data.hasOwnProperty('json_payload')) ? _util.parse_json(message.data.json_payload) : {};
            if ($.isEmptyObject(json) && _util.check_nested(message, 'data.user_data')) {
                json = _util.parse_json(message.data.user_data);
            }
            // console.warn('cometd my_channel() json: ', $.extend(true, {}, json));
            _info('cometd my_channel() msg_type: '+msg_type+', json: %o', json);

            // no msg_type, which is required
            if (!_util.check_obj(msg_type)) {
                _info('cometd my_channel() no msg_type. json: ', json);
                return;
            }

            // check json object for blocked user, and exit function if we find a blocked user
            if (_util.is_user_blocked(json, _data.blocked_users)) {
                _info('cometd my_channel() is_user_blocked returned true. BLOCKING USER. json: ', json);
                return;
            }


            if (json.hasOwnProperty('user') && json.user.gender == 'MAN') {
                if (GP.sdata.my_user.gender == 'MAN' && GP.sdata.my_user.seeking != 'MAN') {
                    _info('cometd my_channel() blocking notification from MAN to MAN not seeking men. json: ', json);
                    return;
                }
            }

            // return here and block growls activities etc for bank sites if not one of these msg types
            var bc_allowed = [
                'user_account_updated','mod_user_credits','blocked_user_added',
                'admin_force_logout','update_user','remove_user','admin_redirect'
            ];
            if (_bank_site === true && _.contains(bc_allowed, msg_type) !== true) {
                _info('bank site stopping here for msg_type: ', msg_type, 'json: ', json);
                return;
            }

            // add msg_type to json obj if msg_type is one of these
            if ($.inArray(msg_type, _data.activity_msg_types) !== -1) {
                json.type = msg_type;
            }
            if (msg_type == 'new_message') {
                // add jgrowl notification
                var is_activity_message = _.intersection(['WINK','QUICKCHAT','FAVORITED','RATED','MEETME'], json.threads[0].tag).length > 0;
                var is_flirt = _.intersection(['FLIRT', 'FLIRT_CENTER'], json.threads[0].tag).length > 0;
                var is_poke = _.intersection(['POKE'], json.threads[0].tag).length > 0;
                var growl_data = {
                    type: 'new_message',
                    thread_id: json.threads[0].thread_id,
                    user: json.users[0],
                    organic: false
                };

                if (is_flirt) {
                    growl_data.text = js_lang.msg_sent_incoming_flt + '...';
                } else if (is_activity_message) {
                    growl_data.text = js_lang.msg_sent_incoming_activity + '...';
                } else if (is_poke) {
                    growl_data.text = js_lang.msg_sent_incoming_ice_breaker + '...';
                } else {
                    growl_data.text = js_lang.msg_sent_incoming + '...';
                    growl_data.organic = true;
                }

                // _vent.trigger('ActivityPane:add_jgrowl_notification', growl_data);
                _vent.trigger('ActivityPane:add_activity', growl_data, true);

                // update MessagePane with new thread/message
                // TODO: figure out why this trigger stops code after it from running with no errors
                _vent.trigger('MessagePane.Inbox:load_thread_from_push', json);
            } else if (msg_type == 'free_growl') {
                json.type = msg_type;
                _vent.trigger('ActivityPane:add_activity', json);
            } else if ($.inArray(msg_type, _data.activity_msg_types) !== -1) {
                // add jgrowl notification for viewed/hovered feed, favorite added etc...
                _vent.trigger('ActivityPane:add_activity', json);
            } else if (msg_type == 'remove_user' || msg_type == 'update_user') {
                if (json.hasOwnProperty('duid') && json.hasOwnProperty('field')) {
                    // don't remove from friendpane if the from_duid is yourself
                    if (json.field == 'friend' && json.value === false && json.from_duid != _data.duid) {
                        _vent.trigger('FriendPane:remove_user', json.duid);
                    }
                }
            } else if (msg_type == 'mod_user_credits') {
                // trigger User:mod_user_credits to update user's shared data (sdata) and update header elements
                _vent.trigger('User:mod_user_credits', json);
            } else if (msg_type == 'blocked_user_added') {
                if (json.blocked_duid) {
                    // trigger User:add_blocked_user to update user's blocked_users duid list
                    _vent.trigger('User:add_blocked_user', json.blocked_duid, json?.blocked_by_duid);
                }
            } else if (msg_type == 'admin_redirect') {
                if (json.redirect_url) {
                    window.location.href = json.redirect_url;
                }  
            } else if (msg_type == 'user_account_updated') {
                // message pushed from user.mod_user api when membership/account_status etc is updated
                if (json.logout) {
                    window.location.href = '/members/user/logout';
                } else {
                    // refresh auth cookie
                    _vent.trigger('User:refresh_auth', json.auth_keys);
                }
                return;
            } else if (msg_type == 'admin_force_logout') {
                // message pushed from admin to log user out when changing to scammer_disabled etc...
                window.location.href = '/members/user/logout';
                return;
            } else if (msg_type == 'vc_start_ppm') {
                // message pushed from videochat.mod_live api when a private chat has been approved and started
// console.log('cometd my_channel() vc_start_ppm msg_type found... calling VChat:start_ppm with json: ', json);

                _vent.trigger('VChat:start_ppm', json);
                return;
            } else if (msg_type == 'refresh_thread') {
                GP.vent.trigger('MessagePane.Thread:reset_thread', json.thread_id);
            }

            // add user to the friends collection
            if (msg_type == 'nf' && _util.check_obj(json.user)) {
                _vent.trigger('FriendPane:add_friend', json);
            }

            // add to the friends collection for hot or not mutual matches
            if (msg_type == 'mm' && _util.check_obj(json.user)) {
                _vent.trigger('FriendPane:add_match', json);
            }

            if (msg_type == 'reload_growl') {
                _vent.trigger('ActivityPane:add_reload_growl');
            }

            // matchgame growl
            if (msg_type == 'mr') {
                _vent.trigger('ActivityPane:add_matchgame_reminder_growl', json);
            }
        },
        handle_activity_feed: function(message) {
            _info('cometd handle_activity_feed() raw message: ', message);

            var json = _util.parse_json(message.data.json_payload);
            _info('cometd handle_activity_feed() parsed json: ', json);

            // check json object for blocked user, and exit function if we find a blocked user
            if (_util.is_user_blocked(json, _data.blocked_users)) {
                _info('cometd handle_activity_feed() is_user_blocked returned true. BLOCKING USER. json: ', json);
                return;
            }

            if (json.hasOwnProperty('has_review_placeholder') && json.has_review_placeholder === true) {
                _info('cometd handle_activity_feed() has_review_placeholder found, skipping... json: ', json);
                return;
            }

            _vent.trigger('ActivityCarousel:add', json);

            // special case: if we are a free male & this chick is hot, pop a free_growl
            if (GP.sdata.my_user.membership == 'FREE' && GP.sdata.my_user.gender == 'MAN' &&
                message.data.msg_type == 'logged_in' && json.show_growl) {

                if (GP.sdata.my_user.country_code == json.country_code) {
                    // US users require a matching state
                    if (json.country_code == 'US' && GP.sdata.my_user.state_code != json.state_code) {
                        return;
                    }

                    // limited to 1 per 2 hours via cookie
                    $.cookie.json = true;
                    var utc_hours = Date.now() / 1000 / 60 / 60;
                    var limit_cookie = $.cookie('flig'); // flig = free logged_in growl, duh!
                    if (typeof(limit_cookie) == 'undefined' || utc_hours - limit_cookie.ts > 2) {
                        // check this only after all other checks for efficiency
                        var show_popups = GP.reqres.request('Page:can_show_popups');
                        if (show_popups) {
                            var growl_data = {
                                type: 'free_growl',
                                duid: json.duid,
                                pic: json.pic,
                                pg_pic: json.pic,
                                max_content_pg_pic: json.pic,
                                max_content_pg13_pic: json.pic,
                                max_content_r_pic: json.pic,
                                max_content_x_pic: json.pic,
                                header: json.username,
                                text: js_lang.growl.logged_in.text,
                            };
                            _vent.trigger('ActivityPane:add_activity', growl_data);

                            // update limit_cookie (will prob use count in the future, for now only ts matters)
                            _util.set_cookie('flig', { count: 1, ts: utc_hours }, 999);
                        }
                    }
                }
            }
        },
        handle_message_thread: function(message) {
            // only need to react to the other user's status changes (not my own)
            if (message.data.duid != _data.duid) {
                if (message.data.status == 'typing') {
                    _vent.trigger('ThreadLayout.thread-'+message.data.thread_id+':show_typing_status');
                } else {
                    _vent.trigger('ThreadLayout.thread-'+message.data.thread_id+':hide_typing_status');
                }

                if (message.data.status == 'messenger_open') {
                    _vent.trigger('MessagePane.Inbox:set_messages_read', message.data.thread_id);
                }
            }
        }
    };

    // wrapper obj for _util.timers (mainly to keep track of timers via _data.timer_ns)
    var _timers = {
        // setup our various timers
        init: function() {
            // check every check_connection_interval what our cometd connection status is and auth logged in status
            // and take appropriate action
            _timers.set(_apis.check_online, _data.check_connection_interval, 'check_connection', true);

            // make sure we have a connection after check_connection_timeout seconds,
            // and switch to regular ws/http from ssl, and then proxy if still not connected
            _timers.set(
                _events.check_connection,
                _data.check_connection_timeout,
                'check_connection'
            );

            // check if we have a connection after 30 seconds, and log success/transport or failure
            _timers.set(
                _events.check_and_log_connection,
                _data.log_connection_timeout,
                'check_and_log_connection'
            );
        },
        set: function(func, milliseconds, timer_name, recurring) {
            // add namespace prefix to named timers, so we can clear easily by namespace
            if (_check_obj(timer_name)) {
                timer_name = _data.timer_ns + timer_name;
            }
            _util.timers.set.call(this, func, milliseconds, timer_name, recurring);
        },
        clear: function(timer_name) {
            if (_check_obj(timer_name)) {
                timer_name = _data.timer_ns + timer_name;
                _util.timers.clear.call(this, timer_name);
            }
        },
        // clears all timers
        clear_all_ns: function() {
            _util.timers.clear_all_ns.call(this, _data.timer_ns);
        },
        // check if a named timer exists
        exists: function(timer_name) {
            if (_check_obj(timer_name)) {
                timer_name = _data.timer_ns + timer_name;
                return _util.timers.exists.call(this, timer_name);
            }
            return false;
        }
    };



    // expose some functions to check connection status, etc...
    self.check_connection = function() {
        var status = _cometD.getStatus();
        return (status == 'connected' || status == 'connecting') ? true : false;
    };

    // allow other modules to grab the cometd instance/obj
    self.get_cometD_obj = function() {
        return _cometD;
    };

    this.addInitializer(function() {
        // don't setup cometd if we are only showing a profile by itself (no header, nav etc...)
        if (typeof _profile_only != 'undefined' && _profile_only) {
            return;
        }

        // get this party started
        _data.init();
        _events.init();
        _timers.init();

        // expose this module's internal handshake_count data
        self.handshake_count = _data.handshake_count;
    });
});


